export const objectKeys = <T extends Object>(obj: T): Array<keyof T> => {
  return Object.keys(obj) as Array<keyof T>;
};
